import React from 'react'
import { IonContent, IonPage } from '@ionic/react'
import Header from '../../components/Header'
import noticeJson from './notice.json'
import NoticeItem from './NoticeItem'

const Notice: React.FC<{}> = (props) => {
    return (
        <IonPage>
            <IonContent className='mybot-content'>
                <Header title='系统通知' />

                {noticeJson.map((item) => (
                    <NoticeItem
                        time={item.time}
                        content={item.content}
                        key={item.time}
                    />
                ))}
            </IonContent>
        </IonPage>
    )
}

export default Notice
